import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=0bc0f0e2"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports